// import { Button, UploadArea } from '@usitsdasdesign/dds-react';
import Text from 'atoms/Text';
import ButtonGroup from 'molecules/ButtonGroup';
import Drawer from 'molecules/Drawer';
import Link from 'next/link';
import FileUpload from './fileUpload';

function BulkUploadDrawer({
    showBulkUploadDrawer = false,
    onHideBulkUploadDrawer,
    onUpload,
    download,
    filesState,
    receivedFiles,
    deleteFile,
    acceptExtensions = ['csv'],
    isDisabled = false,
    title = 'Bulk Upload Allocations',
    desc='Download the template first to bulk upload allocations',
    secondaryDesc,
    secondaryDownload
}) {
    const buttons = [
        {
            label: 'Cancel',
            kind: 'primary',
            onClick: onHideBulkUploadDrawer,
            size: 'l'
        },
        {
            label: 'Upload',
            kind: 'primaryLoud',
            onClick: onUpload,
            size: 'l',
            isDisabled: !filesState?.length || isDisabled,
        },
    ];

    const noteLists = [
        { title: 'Bulk upload should be performed after 7:00 PM (post working hours).' },
        { title: 'Each file can contain a maximum of 1,000 records.' },
        { title: 'Data must be entered strictly as per the provided bulk upload template format.' },
        { title: 'All mandatory fields must be filled for every record before uploading.' },
        { title: 'The process may take 10–15 minutes to complete, depending on the number of records.' },
        {
            title: 'Once the bulk upload is completed, you will receive an email notification with :',
            children: [
                { title: 'A summary of successful and failed records.' },
                { title: 'An attachment containing details of failed records for correction.' },
            ],
        },
    ];

    return (
        <Drawer
            headerMargin="mb-0"
            show={showBulkUploadDrawer}
            width="max-w-[51rem]"
            title={title}
            headerPadding='px-5 pt-4'
            isFooter
            footer={<ButtonGroup buttons={buttons} />}
            onClose={onHideBulkUploadDrawer}
        >
            <Text variant="body">
                {desc}
                <Link className="text-green-700 ml-2 font-bold underline underline-offset-2" href="#" onClick={download}>
                    Download
                </Link>
            </Text>
            {secondaryDesc && secondaryDownload && (
                <Text variant="body" className="mt-2">
                    {secondaryDesc}
                    <Link className="text-green-700 ml-2 font-bold underline underline-offset-2" href="#" onClick={secondaryDownload}>
                        Download
                    </Link>
                </Text>
            )}
            <div className="flex items-end space-x-5 mt-5">
                <div className="md:w-[458px]">
                    <FileUpload
                        acceptExtensions={acceptExtensions}
                        filesState={filesState}
                        receivedFiles={receivedFiles}
                        deleteFile={deleteFile}
                    />
                </div>
            </div>

            <div className="mt-5 px-4 pt-2 pb-3.5 bg-green-900/10 rounded-lg">
                <Text variant="bodySemibold" className="mb-1">
                    Please note:
                </Text>
                <ul>
                    {noteLists.map((item, index) => (
                        <li key={index} className="text-sm list-decimal ml-4 text-black">
                            {item.title}
                            {item.children && (
                                <ul className="list-disc ml-4">
                                    {item.children.map((child, childIndex) => (
                                        <li key={childIndex} className="text-sm text-black">
                                            {child.title}
                                        </li>
                                    ))}
                                </ul>
                            )}
                        </li>
                    ))}
                </ul>
            </div>
        </Drawer>
    );
}

export default BulkUploadDrawer;
